/* unplugin-vue-components disabled */import { render } from "./CefrWords.vue?vue&type=template&id=01cb66b0"
import script from "./CefrWords.vue?vue&type=script&lang=js"
export * from "./CefrWords.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__